import { Injectable } from '@angular/core';
import { getDisplayOrderRef } from '../utils/order-formatting';

@Injectable({ providedIn: 'root' })
export class SupportService {
  private readonly phoneNumber = '918335866656';

  getWhatsAppLink(orderId?: string): string {
    const displayOrderId = orderId ? getDisplayOrderRef(orderId) : undefined;
    const message = displayOrderId
      ? `Hi! I have a question regarding my Order ${displayOrderId} from The Soul Simmer.`
      : `Hi! I'd like to inquire about your cakes.`;

    return `https://wa.me/${this.phoneNumber}?text=${encodeURIComponent(message)}`;
  }

  getCallLink(): string {
    return `tel:+${this.phoneNumber}`;
  }
}
